import {POST} from "../../../Hooks/RequestV2";
import {FormDataInterface} from "../Form";

export default function authenticateUser(data: FormDataInterface, deps: {
    setUserLoginData: (d: any) => void;
    setNotification: (v: any) => void;
    setStatus: (v: any) => void;
    setUser: (u: any) => void;
}): void {

    const { setUserLoginData, setNotification, setStatus, setUser } = deps;

    POST('/check-credentials', data)
        .then((response) => {
            if (response.status === 200){
                setUserLoginData(data);

                response.json().then((json) => {

                    if ((!json.admin && json.saleDepartment.length === 1) || (json.admin && json.saleDepartment.length === 1 && ((json.adminContractors.length === 1 && json.adminOtherContractors.length === 0) || (json.adminContractors.length === 0 && json.adminOtherContractors.length === 1)))){
                        POST('/check-currency-problem', {contractor_id: json.receiver.contractor.id, sale_department_id: json.salesDepartmentInfo[0].id})
                            .then((response) => {
                                if (response.status === 204){
                                    POST('/user/login_auth', data)
                                        .then(() => {
                                            setNotification(null);

                                            if (json.admin){
                                                let contractor: string;

                                                if (json.adminContractors.length === 1){
                                                    contractor = json.adminContractors[0].id;
                                                } else {
                                                    contractor = json.adminOtherContractors[0].id;
                                                }

                                                POST('/user/report', {
                                                    sale_department_id: json.salesDepartmentInfo[0].id,
                                                    contractor_id: json.receiver.contractor.id,
                                                    shop_user_id: json.id
                                                })
                                                    .then((response) => {
                                                        if (response.ok){
                                                            window.location.href = 'https://'+json.salesDepartmentInfo[0].hostName+'?mini-cart=true&contractor='+contractor;
                                                        }
                                                    })
                                            } else {

                                                if (json.salesDepartmentInfo[0].hostName === window.location.hostname){

                                                    POST('/user/report', {
                                                        sale_department_id: json.salesDepartmentInfo[0].id,
                                                        contractor_id: json.receiver.contractor.id,
                                                        shop_user_id: json.id
                                                    })
                                                        .then((response) => {
                                                            if (response.ok){
                                                                window.location.reload();

                                                                setStatus('auth');
                                                                setUser(json);
                                                            }
                                                        })

                                                    return;
                                                }

                                                window.location.href = 'https://'+json.salesDepartmentInfo[0].hostName+'?mini-cart=true';
                                            }


                                            setStatus('auth');
                                            setUser(json);
                                        });
                                } else {
                                    setStatus('not_auth');
                                    setNotification('Z uwagi na podpięcie cennika walutowego nie możesz się zalogować. Skontaktuj się ze swoim opiekunem lub z administratorem.');

                                    return;
                                }
                            });

                        return;
                    } else {
                        setUser(json);
                        setStatus('auth');

                        return;
                    }
                });
            } else if (response.status === 400) {
                setStatus('error');
            } else {
                setStatus('not_auth');
            }
        });
}